import {t} from "../utils/filters";
import { acceptHot } from '../utils/hot';

// Async load the vue module
Promise.all([
    import(/* webpackChunkName: "vue" */ 'vue'),
    import(/* webpackChunkName: "vueevents" */ 'vue-events'),
    import(/* webpackChunkName: "gallerymodalwrapper" */ '../../vue/GalleryModal/GalleryModalWrapper.vue')
]).then(([{default: Vue}, {default: VueEvents}, {default: GalleryModalWrapper}]) => {
    Vue.use(VueEvents);
    Vue.filter('t', t);
    const app = new Vue({
        components: {
            GalleryModalWrapper: GalleryModalWrapper,
        },
        data: {}
    });

    app.$events.$on('ready', () => {
        if (window.launchGallery) {
            app.$events.$emit('loadProject', window.launchGallery);
            return;
        }
        const key = '#view-project:';
        const hash = window.location.hash;
        if (!hash.startsWith(key)) {
            return;
        }
        const slug = hash.substring(key.length);

        app.$events.$emit('loadProject', slug);
    });

    app.$mount('#gallery-modal');

    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-expand-gallery]');
        if (!trigger) {
            return;
        }

        e.preventDefault();
        app.$events.$emit('loadProject', trigger.dataset.expandGallery);
    });

});

acceptHot(import.meta, typeof module !== 'undefined' ? module : undefined);
